// FECOA-2038: caregiver schedules build no survey windows until a caregiver is
// linked. The API reports those schedules as `pending_caregiver_schedules` on
// the enrollment response and the participant detail payload so the UI can say
// why caregiver surveys are missing instead of "no surveys scheduled".

export const CAREGIVER_PENDING_ENROLL_TITLE = 'Caregiver surveys pending';
export const CAREGIVER_PENDING_ENROLL_BODY =
  'This participant does not have a caregiver linked. Caregiver surveys will become available after a caregiver is linked.';

export const CAREGIVER_PENDING_PAGE_TITLE = 'Caregiver surveys are pending';
export const CAREGIVER_PENDING_PAGE_BODY =
  'This participant has caregiver surveys scheduled, but no caregiver is currently linked. Caregiver surveys will appear after a caregiver is linked.';

export const hasPendingCaregiverSchedules = (payload) =>
  Array.isArray(payload?.pending_caregiver_schedules) &&
  payload.pending_caregiver_schedules.length > 0;

// Enrollment notice: skip it when the form itself just linked a caregiver,
// since the link backfills the caregiver windows.
export const shouldNotifyCaregiverPending = (enrollResponse, caregiversAdded = 0) =>
  hasPendingCaregiverSchedules(enrollResponse) && caregiversAdded === 0;
